<template>
  <div class="user-info">
    <!-- 修改公司监控数据 -->
    <vxe-modal
        v-model="isShowModal"
        width="600"
        height="380"
        destroy-on-close
    >
      <p slot="header" class="box-tit-211130">
        <span>修改浮动数据:  {{ formData.name }}</span>
      </p>
      <vxe-form
          ref="xForm"
          title-align="right"
          title-width="160"
          :data="formData"
          :rules="formRules"
          style="margin-top: 20px; padding-right: 50px"
          @submit="submitEvent"
      >
        <vxe-form-item title="交易总金额 （万元）" field="floatTotalAmount" span="24">
          <template v-slot="scope">
            <vxe-input
                v-model="formData.floatTotalAmount"
                placeholder="陆运浮动数据#水运浮动数据"
                @input="$refs.xForm.updateStatus(scope)"
                style="width: 400px"
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="交易总数量（万吨）" field="floatTotalNumber" span="24">
          <template v-slot="scope">
            <vxe-input
                v-model="formData.floatTotalNumber"
                placeholder="陆运浮动数据#水运浮动数据"
                @input="$refs.xForm.updateStatus(scope)"
                style="width: 400px"
            ></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="累计装船及发车" field="floatDeparts" span="24">
          <template v-slot="scope">
            <vxe-input
                v-model="formData.floatDeparts"
                placeholder="发车浮动数据#装船浮动数据"
                @input="$refs.xForm.updateStatus(scope)"
                style="width: 400px"
            ></vxe-input>
          </template>
        </vxe-form-item>
<!--        <vxe-form-item title="累计成交订单" field="floatOrders" span="24">-->
<!--          <template v-slot="scope">-->
<!--            <vxe-input-->
<!--                v-model="formData.floatOrders"-->
<!--                placeholder="陆运浮动数据#水运浮动数据"-->
<!--                @input="$refs.xForm.updateStatus(scope)"-->
<!--                style="width: 400px"-->
<!--            ></vxe-input>-->
<!--          </template>-->
<!--        </vxe-form-item>-->
        <vxe-form-item align="right" span="24" style="margin-top: 20px">
          <vxe-button
              status="primary"
              style="width: 140px; border-radius: 0px"
              @click="cancelSubmit"
          >取消
          </vxe-button>
          <vxe-button
              type="submit"
              status="primary"
              style="width: 140px; border-radius: 0px"
          >保存
          </vxe-button>
        </vxe-form-item>
      </vxe-form>
    </vxe-modal>
  </div>
</template>

<script>

import {apiGet, apiPost} from "@/utils/api";
import {hideLoading, showLoading} from "@/utils/util";

export default {
  name: 'EditUserMonitorData',
  data() {
    return {
      isShowModal: false,
      formData: {
        "floatDeparts": "",
        "floatOrders": "",
        "floatTotalAmount": "",
        "floatTotalNumber": ""
      },
      formRules: {
        "floatDeparts": [{required: true, message: '请输入累计装船及发车，格式：发车浮动数据#装船浮动数据', trigger: 'blur'}],
        "floatOrders": [{required: true, message: '请输入累计成交订单，格式：陆运浮动数据#水运浮动数', trigger: 'blur'}],
        "floatTotalAmount": [{required: true, message: '请输入交易总金额（万元），格式：陆运浮动数据#水运浮动数据', trigger: 'blur'}],
        "floatTotalNumber": [{required: true, message: '请输入交易总数量（万吨），格式：陆运浮动数据#水运浮动数据', trigger: 'blur'}]
      },
      isTrue: false,
      userId: 0,
    };
  },
  methods: {
    async init(userId) {
      this.userId = userId
      await this.getData()
      this.isShowModal = true;
    },
    async getData() {
      let res = await apiGet('api/auth/', 'baseUserSign/getUserSignById', {
        userId: this.userId
      });
      console.log(res)

      this.formData.floatDeparts = res.data.floatDeparts
      this.formData.floatOrders = res.data.floatOrders
      this.formData.floatRegisters = res.data.floatRegisters
      this.formData.floatTotalAmount = res.data.floatTotalAmount
      this.formData.floatTotalNumber = res.data.floatTotalNumber
      this.formData.id = res.data.id

      if (undefined != this.$refs.xForm) {
        this.$refs.xForm.clearValidate();
      }
    },
    async fullValidEvent() {
      const errMap = await this.$refs.xForm
          .validate()
          .catch((errMap) => errMap);
      if (!errMap) {
        this.submitEvent();
      }
    },
    async submitEvent() {
      showLoading()
      let res = await apiPost('api/auth/', 'baseUserSign/updateUserFloat', this.formData);
      hideLoading()
      if (res.status == 1) {
        this.$Message.success("操作成功")
        this.isShowModal = false;
      } else {
        this.$Message.error(res.message)
      }
    },
    cancelSubmit() {
      this.isShowModal = false;
    },
  },
};
</script>

<style>
.user-info {
  float: right;
  color: #333;
}

.user-info .name {
  cursor: pointer;
}

.user-info .name em {
  padding: 0 5px 0 10px;
}

.ivu-layout-header .vxe-modal--header {
  line-height: 1.5;
}

.top-change-pwd .vxe-input .vxe-input--suffix,
.top-change-pwd .vxe-input .vxe-input--extra-suffix {
  top: 15px !important;
}

@media screen and (max-width: 750px) {
}
</style>